import * as React from 'react';
import Divider from 'material-ui/Divider';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, withProps, withHandlers } from 'recompose';
import { get, uniqBy } from 'lodash';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import { InlineGridField, InlineGrid } from '@components/form';
import { withNotifications } from '@components/hoc/withNotifications';

import {
  eventsFormParticipantsGridColumns,
  wantedVehiclesGridColumns,
  weaponsGridColumns,
  dogsGridColumns
} from '@modules/events/_eventsColumns';
import { EventsFormParticipantsParticipantsForm } from '@modules/events/EventsFormParticipantsParticipantsForm';
import { EventsFormParticipantsVehiclesForm } from '@modules/events/EventsFormParticipantsVehiclesForm';
import { EventsFormParticipantsWeaponsForm } from '@modules/events/EventsFormParticipantsWeaponsForm';
import { EventsFormParticipantsDogsForm } from '@modules/events/EventsFormParticipantsDogsForm';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import { EventsFormParticipantsDogsModal } from './EventsFormParticipantsDogsModal';
import { deleteParticipant } from './_eventsActions';
import { EventsParticipantCopyToClipboard } from '@modules/events/EventsParticipantCopyToClipboard';
import { parseBool } from '@utils/utils';

const mapStateToProps = state => ({
  dogs: get(state, 'form.module-events.values.dogs', [])
});

const mapDispatchToProps = dispatch => ({
  setDogs: dogs => dispatch(change('module-events', 'dogs', dogs))
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNotifications({ deleteParticipant }),
  withProps(() => {
    const {
      config: {
        extensions: { doglust, weapons }
      }
    } = getConfigurationContext();
    return {
      doglust,
      weapons: parseBool(weapons || '')
    };
  }),
  withHandlers({
    onSaveDogs: ({ setDogs, dogs }) => newDogs => {
      const removedDuplicates = uniqBy([...dogs, ...newDogs], d => d.id);
      setDogs(removedDuplicates);
    }
  })
);

const View: React.SFC<any> = ({ disabled, doglust, weapons, onSaveDogs, deleteParticipantNotify }) => {
  const Modal = React.useMemo(() => withProps({ doglust, onSaveDogs })(EventsFormParticipantsDogsModal), [
    doglust,
    onSaveDogs
  ]);

  return (
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <h4>Osoby</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="participants"
            Form={EventsFormParticipantsParticipantsForm}
            ActionBar={EventsParticipantCopyToClipboard}
            columns={eventsFormParticipantsGridColumns}
            showCheckboxes={true}
            adding={!disabled}
            editing={!disabled}
            deleting={!disabled}
            onDelete={checkedItems => {
              checkedItems.forEach(participant => deleteParticipantNotify(get(participant, 'id')));
            }}
            gridProps={{
              version: 2
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <Divider />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <h4>Vozidla</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="vehicles"
            Form={EventsFormParticipantsVehiclesForm}
            columns={wantedVehiclesGridColumns}
            showCheckboxes={true}
            adding={!disabled}
            editing={!disabled}
            deleting={!disabled}
          />
        </Col>
      </Row>

      {weapons && (
        <React.Fragment>
          <Row>
            <Col className="grid-system-margin" />
          </Row>

          <Row>
            <Col md={12}>
              <Divider />
            </Col>
          </Row>

          <Row>
            <Col className="grid-system-margin" />
          </Row>

          <Row>
            <Col md={12}>
              <h4>Zbraně</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                name="weapons"
                Form={EventsFormParticipantsWeaponsForm}
                columns={weaponsGridColumns}
                showCheckboxes={true}
                adding={!disabled}
                editing={!disabled}
                deleting={!disabled}
              />
            </Col>
          </Row>
        </React.Fragment>
      )}

      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <Divider />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <h4>Psi</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="dogs"
            Form={EventsFormParticipantsDogsForm}
            columns={dogsGridColumns}
            showCheckboxes={true}
            adding={!disabled}
            editing={!disabled}
            deleting={!disabled}
            ActionBar={Modal}
            version="3"
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default enhance(View) as any;



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormParticipants.tsx